import axios from 'axios'
import { CANCELAR_SEGURO_RESERVA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cancelarSeguroReservas (empresaId, motivo, reservas) {
  const url = `${URL}/seguro/cancelar`;
  return dispatch => axios.post(url,{ empresaId, motivo,  reservas} , SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CANCELAR_SEGURO_RESERVA,
        payload: response
      })
  );
}

